/* Progressive enhancement — alles werkt ook zonder JS. */
(function () {
  'use strict';
  // Sectie-inkomst (opacity/transform), respecteert prefers-reduced-motion via CSS
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Stagger: kinderen van [data-stagger] krijgen oplopende vertraging (CSS --i)
  document.querySelectorAll('[data-stagger]').forEach(function (wrap) {
    Array.prototype.forEach.call(wrap.children, function (el, i) { el.style.setProperty('--i', i); });
  });

  // Header: compacter + schaduw zodra de pagina scrolt (alleen class-toggle, CSS doet de rest)
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Drawers (<dialog>): focus, Escape, klik buiten
  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var d = document.getElementById(btn.getAttribute('data-drawer-open'));
      if (d && typeof d.showModal === 'function') { d.showModal(); var f = d.querySelector('a,button,input,select'); if (f) f.focus(); }
    });
  });
  document.querySelectorAll('dialog[data-drawer]').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.querySelectorAll('[data-drawer-close]').forEach(function (c) { c.addEventListener('click', function () { d.close(); }); });
  });

  // Gerelateerde producten: sectie nalezen via Section Rendering API (aanbevelingen zijn pas beschikbaar met product_id)
  document.querySelectorAll('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { box.innerHTML = inner.innerHTML; box.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); }
    }).catch(function () {});
  });

  // Productgalerij: thumbnails wisselen hoofdbeeld (zonder JS: alle beelden onder elkaar)
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.querySelector('img');
        if (!main || !img) return;
        main.src = img.getAttribute('data-full') || img.src; main.srcset = img.getAttribute('data-full-srcset') || ''; main.alt = img.alt;
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Voorraadmaximum op aantal-velden (wens eigenaar 23-10): boven het maximum direct terugzetten + rode melding; onder of gelijk: melding weg.
  var qtyNoteText = function (max) {
    var tpl = (document.documentElement.getAttribute('data-qty-max-note') || 'Maximaal __COUNT__ op voorraad');
    return tpl.replace('__COUNT__', String(max));
  };
  var bindQtyMax = function (input) {
    if (input.hasAttribute('data-qty-bound')) return; input.setAttribute('data-qty-bound', '1');
    var note = input.parentElement ? input.parentElement.querySelector('[data-qty-note]') : null;
    var clamp = function () {
      var max = parseInt(input.getAttribute('data-qty-max'), 10);
      if (isNaN(max)) { if (note) note.hidden = true; return; }
      var v = parseInt(input.value, 10);
      if (!isNaN(v) && v > max) {
        input.value = String(max);
        if (note) { note.textContent = qtyNoteText(max); note.hidden = false; }
      } else if (note && !input.value) {
        note.hidden = true;
      } else if (note && note.hidden === false && !isNaN(v) && v < max) {
        note.hidden = true;
      }
    };
    ['input', 'change', 'blur'].forEach(function (ev) { input.addEventListener(ev, clamp); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') clamp(); });
    clamp();
  };
  document.querySelectorAll('input[data-qty-max]').forEach(bindQtyMax);
  // PDP: bij een variantwissel het maximum van die variant overnemen
  var pdpVariant = document.getElementById('pdp-variant'), pdpQty = document.getElementById('pdp-qty');
  if (pdpVariant && pdpQty) {
    pdpVariant.addEventListener('change', function () {
      var opt = pdpVariant.options[pdpVariant.selectedIndex], m = opt ? opt.getAttribute('data-qty-max') : null;
      if (m === null) { pdpQty.removeAttribute('max'); pdpQty.removeAttribute('data-qty-max'); }
      else { pdpQty.setAttribute('max', m); pdpQty.setAttribute('data-qty-max', m); }
      bindQtyMax(pdpQty);
      pdpQty.dispatchEvent(new Event('change'));
    });
  }

  // Bevestigingsset-keuze op PDP: zet gekozen set als extra regel in de winkelwagen (echt product, eigen voorraad)
  document.querySelectorAll('[data-mounting-set-form]').forEach(function (form) {
    var select = form.querySelector('select[name="mounting_set_variant"]');
    var hidden = form.querySelector('input[name="items[1][id]"]');
    if (!select || !hidden) return;
    var toggle = function () {
      var v = select.value;
      hidden.value = v; hidden.disabled = !v;
      var q = form.querySelector('input[name="items[1][quantity]"]'); if (q) q.disabled = !v;
    };
    select.addEventListener('change', toggle); toggle();
  });

  // Maatwerk-offerteformulier: client-side validatie (server-side validatie is verplicht en volgt in de opvolgroute)
  document.querySelectorAll('[data-quote-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var ok = true;
      form.querySelectorAll('[data-required]').forEach(function (field) {
        var input = field.querySelector('input,select,textarea');
        var bad = !input || !input.value || (input.type === 'number' && !(parseFloat(input.value) > 0));
        field.setAttribute('data-invalid', bad ? 'true' : 'false');
        var err = field.querySelector('.error'); if (err) err.hidden = !bad;
        if (bad) ok = false;
      });
      var w = form.querySelector('[name="contact[waterdoorlatend]"]:checked');
      var max = form.querySelector('[name="contact[zijde_1_cm]"]');
      if (w && w.value === 'nee' && max && parseFloat(max.value) > 600) {
        ok = false; var m = form.querySelector('[data-max-error]'); if (m) m.hidden = false;
      }
      if (!ok) { e.preventDefault(); var first = form.querySelector('[data-invalid="true"] input, [data-invalid="true"] select'); if (first) first.focus(); }
    });
  });

  // Cookie-instellingen: heropent de voorkeuren van de Shopify-cookiebanner (privacyverklaring §5). Knop pas tonen als de banner-API er is.
  var cookieBtns = document.querySelectorAll('[data-cookie-settings]');
  if (cookieBtns.length) {
    var showCookieBtn = function () {
      if (!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function')) return false;
      cookieBtns.forEach(function (b) { b.hidden = false; b.addEventListener('click', function () { window.privacyBanner.showPreferences(); }); });
      return true;
    };
    if (!showCookieBtn()) { var tries = 0; var t = setInterval(function () { if (showCookieBtn() || ++tries > 20) clearInterval(t); }, 500); }
  }
})();
